<template>
    <vue-custom-scrollbar id="workspace-result-designs" class="workspace-module-container">
        <!--        v-show="false" Костыль чтобы перерендерить компонент-->
        <div v-show="false">{{lengthUploadedPhotos}}</div>
        <div id="result-designs-container">

            <div class="result-lite-grid">
                <div class="result-lite-grid-element">
                    <div class="project-preview">
                        <img class="project-preview-image img-central pointer" :src="getPhotoDataUrl(Object.keys(photos)[0])"
                             v-on:click="showModal('modal-result-photo', getPhotoDataUrl(Object.keys(photos)[0]))"/>
                    </div>



                    <div class="wide-result-button top-rounding bot-rounding" v-on:click="createPDF()">
                        <SVGPrint/>
                        <span class="wide-result-button-text">Распечатать ваш заказ</span>
                    </div>
                </div>



                <div class="result-lite-grid-element">
<!--                    <div id="projects-table-label">Список товаров</div>-->
<!--                    <div class="result-label-project-name">-->
<!--                        <span class="text-project">Проект: </span>-->
<!--                        <span class="name-project bold-text">{{projectName}}</span>-->
<!--                    </div>-->
                    <div id="projects-table-container">
                        <table class="result-table">
                            <thead>
                            <tr class="head-tr">
                                <th class="field-number">№</th>
                                <th>Эскиз</th>
                                <th>Наименование</th>
                                <th>Тип продукции</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="body-tr row" v-for="(product, index) in productsCost">
                                <td>
                                    <span class="table-data-central">{{index + 1}}</span>
                                </td>
                                <td>
                                    <img class="result-material-img" :src="urlForPhoto(product.src)"/>
                                </td>
                                <td>
                                    <span class="table-data">{{product.name}}</span>
                                </td>
                                <td>
                                    <span class="table-data">{{translateProductType(product.type)}}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </vue-custom-scrollbar>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import {modalMethods, urlForFileStorage, urlForStaticVue} from "../../common";
// import {renderDesign} from "../../fabric/libs/renderDesign";
import {imgIsLoadingWhite} from "../../ImgIsLoadingWhite";
import SVGAdminDeleteRow from "../../SVG/SVGAdminDeleteRow";
import SVGPrint from "../../SVG/SVGPrint";
import {loadResultPDF} from "../../../reportGenerator/createPdfLite";

export default {
    name: "WorkspaceResultLite",
    mixins: [urlForFileStorage, modalMethods, urlForStaticVue],
    components: {
        SVGPrint,
        vueCustomScrollbar,
        SVGAdminDeleteRow
    },
    data() {
        return {
            types: {
                wall: 'Фасад',
                additional: 'Доборный элемент'
            }
        }
    },
    computed:{
        lengthUploadedPhotos(){
            return this.$store.getters["resultImg/LENGTH_UPLOADED_PHOTOS"];
        },
        photos(){
            return this.$store.getters["active/GET_ALL_PHOTO"];
        },
        idDesign(){
            return this.$route.params.designID;
        },
        projectName(){
            return this.$store.getters["active/NAME"];
        },
        productsCost() {
            return this.$store.getters["costLite/PRODUCTS_COST"];
        },
    },
    methods:{
        getPhotoDataUrl(idPhoto){
            const photoSrc = this.$store.getters["resultImg/PHOTO_BASE64_BY_ID"](idPhoto, this.idDesign);
            if(photoSrc){
                return this.$store.getters[`projectConfiguration/GENERATE_URL`](photoSrc);
            } else {
                return imgIsLoadingWhite;
            }
        },
        translateProductType(type) {
            return this.types[type]
        },
        urlForPhoto(url) {
            return this.$store.getters[`projectConfiguration/GENERATE_URL`](url);
        },
        async createPDF() {
            if(!this.$store.state.resultImg.allUploaded){
                alert('Дождитесь загрузки изображений ...');
                return;
            }
            const photos = await this.$store.dispatch("resultImg/GET_UPLOADED_PHOTOS_BASE64", {
                idsPhotos: Object.keys(this.$store.getters["active/GET_ALL_PHOTO"]),
                idsDesigns: [this.$store.state.route.params.designID]
            });
            const promisePDF = loadResultPDF(this.$store.getters["costLite/PRODUCTS_COST"], photos);
            await this.$store.dispatch('IN_PROGRESS', promisePDF);
        }
    },
    created() {
        this.$store.dispatch('resultImg/GET_DESIGN_PHOTO', {
            designID: this.idDesign,
            photoID: Object.keys(this.photos)[0]
        });
        // this.$store.dispatch('resultImg/LOAD_ALL_DESIGN_PHOTO', {
        //     idsDesigns: [this.idDesign],
        //     idsPhotos: Object.keys(this.$store.getters["active/GET_ALL_PHOTO"])
        // });
    },
    mounted() {
        this.$store.dispatch('costLite/GET_COST');
    },
    destroyed() {
        // this.$store.commit('resultImg/CLEAR');
    }
}
</script>

<style scoped>
#result-designs-container {
    padding: 50px 0 0 40px;
}

#workspace-result-designs {
    background-color: #F2F2F2;
    user-select: none;
}

.img-central{
    object-position: center !important;
}

#projects-table-label {
    font-size: 32px;
    font-weight: bold;
    color: #303030;
}

#projects-table-container {
    width: auto;
    height: auto;
    margin-top: 10px;
    margin-right: 40px;
    margin-bottom: 40px;
    background-color: white;
    padding: 40px;
    border-radius: 4px;
    box-sizing: border-box;
}

.result-lite-grid {
    display: grid;
    grid-template-columns: max-content auto;
    grid-column-gap: 10px;
}

.result-label-project-name {
    color: #303030;
    margin: 15px 0;
}

.result-material-img {
    width: 150px;
    height: 75px;
    object-fit: cover;
}

.field-number {
    width: 60px;
}

table {
    border-collapse: collapse;
    table-layout: fixed;
    height: 100% !important;
    width: 100%;
    color: #626262;
    background-color: white;
    /*font-size: 20px;*/
    box-sizing: border-box;
}

th, td {
    padding: 8px;
    text-align: center;
    border-bottom: 1px solid #ddd;
}

.body-tr:hover {
    background-color: #E9E9E9;
}

.wide-result-button {
    border: 2px solid #F2F2F2;
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 5px;
    padding: 10px 10px;
    /*color: #939393;*/
    /*font-size: 18px;*/
    cursor: pointer;
    user-select: none;
    /*background-color: white;*/
    width: 280px;
    margin: 10px;
    font-weight: bold;
    color: white;
    background-color: #d83336;
}

.wide-result-button:hover {
    background-color: #b82325;
}

.wide-result-button:active {
    background-color: #d83336;
}

.wide-result-button-text {
    margin-top: 2px;
    /*color: #303030;*/
}

.top-rounding {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom: 1px solid #F2F2F2;
    margin-top: 20px;
}

.bot-rounding {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top: 1px solid #F2F2F2;
    margin-bottom: 20px;
}

.pointer {
    cursor: pointer;
}
</style>
